import { MenuItem, TextField } from '@mui/material';
import React from 'react';

import { useGetBitsoBanksByCountryCodeQuery } from '@/api/v1';
import { BitsoBank } from '@/types/bitsoBank';

interface Props {
  name: string;
  label: string;
  value?: string;
  fullWidth?: boolean;
  countryCode: string;
  onChange?(event: React.ChangeEvent<HTMLInputElement>): void;
}

export const BanksByCountrySelect: React.FC<Props> = (props: Props): React.ReactElement => {
  const { name, label, value, fullWidth, countryCode, onChange } = props;
  const { data: banks = [] } = useGetBitsoBanksByCountryCodeQuery(countryCode);

  return (
    <TextField
      name={name}
      label={label}
      select={true}
      value={value}
      fullWidth={fullWidth}
      onChange={onChange}>
      {banks.map(
        (bank: BitsoBank): React.ReactElement => (
          <MenuItem key={bank.id} value={bank.code}>
            {bank.name}
          </MenuItem>
        ),
      )}
    </TextField>
  );
};
